import { makeStyles } from '@material-ui/core';
import EmptyIcon from '../../../assets/icons/empty-state-icon.svg';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  description: {
    fontSize: 16,
    fontWeight: 400,
    margin: 0,
  },
  title: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
}));

const EmptyState = ({
  title,
  description,
  Icon,
}: {
  title: string;
  description: string;
  Icon?: string;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img src={Icon || EmptyIcon} alt="Empty state" />
      <p className={classes.title}>{title}</p>
      <p className={classes.description}>{description}</p>
    </div>
  );
};

export default EmptyState;
